@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;
@use '../../styling/form-controls.scss' as *;

.ToggleButton {
  @extend %font-family-primary;
  @extend %form-control-font;

  color: $theme-color-text;
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 0.75em;
  align-items: center;
  font-weight: $font-weight-semibold;

  &.toggleButtonRightPosition {
    direction: rtl;
    display: flex;
    justify-content: space-between;
  }

  .iconColor {
    color: $theme-color-tab-label-unselected;
  }

  svg {
    width: 10px;
    height: 10px;
    background: $theme-color-background;
    border-radius: 20px;
  }

  p {
    color: $theme-color-tab-label-unselected;
    font-size: 11px;
    font-weight: $font-weight-semibold;
    line-height: $line-height-normal;
    text-align: right;
    align-items: center;
    align-self: center;
  }

  button {
    background: $theme-color-checkbox-disabled-border;
    border: none;
    text-align: left;
    width: 44px;
    height: 24px;
    border-radius: 12px;
    padding: 2px !important;
    cursor: pointer;
    font-size: 0;
    column-gap: 4px;

    &[disabled] {
      pointer-events: none;
      background-color: $theme-color-sub-background;
      opacity: 0.4;
    }
  }

  button:hover {
    background: $theme-button-toggle-hover;

    &[disabled] {
      pointer-events: none;
      opacity: 0.4;
    }
  }

  button:active {
    background: $theme-color-checkbox-disabled-border;
    box-shadow: 0 1px 2px $color-container-shadow-D, 0 0 0 2px $theme-color-background, 0 0 0 4px $color-purple-hover-background;
    border-radius: 12px;
  }

  &.withIconLabelText {
    button {
      display: inline-flex;
      padding: 2px 8px 2px 2px !important;
      width: auto;
    }
  }

  span {
    display: inline-flex;
    border-radius: 50%;
    border: none;
    width: 20px;
    height: 20px;
    background: $theme-color-background;
    justify-content: center;
    align-items: center;
  }

  &.isOn {
    button {
      background: $color-primary-purple;
      text-align: right;

      &[disabled] {
        pointer-events: none;
        opacity: 0.4;
      }
    }

    .iconColor {
      color: $color-primary-purple;
    }

    &.withIconLabelText {
      button {
        display: inline-flex;
        padding: 2px 2px 2px 8px !important;
        width: auto;
      }
    }

    button:hover {
      background: $theme-color-focus;

      &[disabled] {
        pointer-events: none;
        opacity: 0.4;
      }
    }

    button:active {
      background: $color-primary-purple;
    }

    p {
      color: $color-white;
      font-size: 11px;
      font-weight: $font-weight-semibold;
      line-height: $line-height-normal;
      text-align: left;
      align-items: center;
      align-self: center;
    }
  }
}
